import productReducer from './ProductReducer';
import productDocumentsReducer from './ProductDocumentsReducer';
import { combineReducers } from '@reduxjs/toolkit';

export const productDetailReducers = combineReducers({
	product: productReducer,
	documents: productDocumentsReducer
});